import { IVector3 } from 'sharedtypes/math';
import { CLOUDFRONT_URL } from './globals';

const NEW_ENV_URL = `${CLOUDFRONT_URL}environment_v5/`;

export interface IPresetOptions {
    skydiffuse: string;
    skybrightness: number;
    lightOrientation: IVector3;
}

export interface IPresetEnvironment {
    type: 'cubetexture';
    option: IPresetOptions;
    thumbnail: string;
    name: string;
}

export const EnvironmentList: IPresetEnvironment[] = [
    {
        type: 'cubetexture',
        option: {
            skydiffuse: `${NEW_ENV_URL}4.env`,
            lightOrientation: { x: 0, y: 0, z: 0 },
            skybrightness: 1,
            // lightOrientation: { x: -30, y: 180, z: 0 },
        },
        thumbnail: `${NEW_ENV_URL}Home-Studio.jpg`,
        name: 'Home Studio'
    },
    {
        type: 'cubetexture',
        option: {
            skydiffuse: `${NEW_ENV_URL}6.env`,
            lightOrientation: { x: 0, y: 0, z: 0 },
            // lightOrientation: { x: 20, y: -50, z: 0 },
            skybrightness: 1,
        },
        thumbnail: `${NEW_ENV_URL}Hgh-Contrast-Studio.jpg`,
        name: 'High Contrast Studio'
    },
    {
        type: 'cubetexture',
        option: {
            skydiffuse: `${NEW_ENV_URL}8.env`,
            lightOrientation: { x: 0, y: 0, z: 0 },
            // lightOrientation: { x: 30, y: 80, z: 0 },
            skybrightness: 1.33,
        },
        thumbnail: `${NEW_ENV_URL}Metallic-Studio.jpg`,
        name: 'Metallic Studio'
    },
    {
        type: 'cubetexture',
        option: {
            skydiffuse: `${NEW_ENV_URL}9.env`,
            lightOrientation: { x: 0, y: 0, z: 0 },
            skybrightness: 1,
        },
        thumbnail: `${NEW_ENV_URL}White-Room.jpg`,
        name: 'White Room'
    },
    {
        type: 'cubetexture',
        option: {
            skydiffuse: `${NEW_ENV_URL}Corsica-Beach.env`,
            lightOrientation: { x: 0, y: 0, z: 0 },
            // lightOrientation: { x: 20, y: -50, z: 0 },
            skybrightness: 0.5,
        },
        thumbnail: `${NEW_ENV_URL}Corsica-Beach.jpg`,
        name: 'Corsica Beach'
    },
    {
        type: 'cubetexture',
        option: {
            skydiffuse: `${NEW_ENV_URL}photo_studio_loft_hall.env`,
            lightOrientation: { x: 0, y: 0, z: 0 },
            skybrightness: 0.5,
        },
        thumbnail: `${NEW_ENV_URL}Colorful-Loft.jpg`,
        name: 'Colorful Loft'
    },
    {
        type: 'cubetexture',
        option: {
            skydiffuse: `${NEW_ENV_URL}spiaggia_di_mondello.env`,
            lightOrientation: { x: 0, y: 0, z: 0 },
            skybrightness: 1,
        },
        thumbnail: `${NEW_ENV_URL}Spiaggia-Beach.jpg`,
        name: 'Spiaggia Beach'
    },
    {
        type: 'cubetexture',
        option: {
            skydiffuse: `${NEW_ENV_URL}studio_small_09.env`,
            lightOrientation: { x: 0, y: 0, z: 0 },
            skybrightness: 0.6,
        },
        thumbnail: `${NEW_ENV_URL}Big-Studio.jpg`,
        name: 'Big Studio'
    },
];
